"use client";

import { Box, Grid, Typography } from "@mui/material";
import Image from "next/image";

import LeadForm from "./form";

export default function AffordableLeadForm() {
  const calendlyUrl = process.env.NEXT_PUBLIC_AFFORDABLE_CALENDLY_LINK || "";
  const calendlyEmbedUrl = calendlyUrl
    ? `${calendlyUrl}${calendlyUrl.includes("?") ? "&" : "?"}hide_event_type_details=1`
    : "";
  console.log(calendlyEmbedUrl);
  return (
    <>
      <div className="background">
        <Image
          src="/affordableBackground2.png"
          alt=""
          aria-hidden="true"
          className="background-media"
          fetchPriority="high"
          priority
          fill
          sizes="100vw"
          quality={60}
        />
        <Grid container className="flex-container">
          <Grid size={{ xs: 12, md: 12, lg: 6 }}>
            <div
              className="center-align"
              style={{
                minHeight: "60vh",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <h1 className="affordable-heading">
                Save Money and Live More Comfortably
              </h1>
            </div>
          </Grid>{" "}
          <Grid size={{ xs: 12, md: 12, lg: 6 }}>
            <div className="center-align">
              <div className="form">
                <div className="lead-form-card-top">
                  <p className="lead-form-eyebrow">Request Your</p>
                  <h2 className="lead-form-heading">
                    Free Inspection, Consultation & Quote
                  </h2>
                </div>
                <iframe
                  title="Schedule a consultation"
                  width="100%"
                  height="700"
                  style={{ minHeight: 700, border: "none" }}
                  src={calendlyEmbedUrl}
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>
            </div>
          </Grid>{" "}
        </Grid>
      </div>
    </>
  );
}
